export const FILTER_BOX_CONFIRMATION_DATE_FILTER = 'confirmationDateFilter';
export const FILTER_BOX_DELIVERY_STATUS_FILTER = 'deliveryStatusFilter';
export const FILTER_BOX_INVOICE_STATUS_FILTER = 'invoiceStatusFilter';
export const FILTER_BOX_BILLING_DATE_FILTER = 'billingDateFilter';
export const FILTER_BOX_BILLING_TYPE_FILTER = 'billingTypeFilter';
